import type { ComponentProps } from 'react';
import type React from 'react';

import { Button } from '@change-corgi/design-system-legacy/components/actions';

import { useIsSunriseEnabled } from '../../hooks/isSunriseEnabled';

import type { MobileModalContext } from './shared/types';
import { useMobileModalContext } from './shared/useMobileModalContext';

type Props = Omit<ComponentProps<typeof Button>, 'onClick'> & {
	inverted?: boolean;
	onClick?: (context: MobileModalContext) => void;
};

export const CustomButton: React.FC<Props> = ({ children, inverted, onClick, ...rest }) => {
	const context = useMobileModalContext();

	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();

	return (
		// eslint-disable-next-line @change-corgi/require-data-qa-attribute
		<Button
			variant={inverted && !isSunriseEnabled ? 'secondaryEmphasis' : 'primary'}
			sx={{ width: '100%' }}
			onClick={() => onClick?.(context)}
			{...rest}
		>
			{children}
		</Button>
	);
};
